var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDislike = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2891 3.24575L9.03321 1.44915C8.74213 1.14972 8.0872 0.999999 7.65059 0.999999L4.88534 0.999999C4.01211 0.999999 3.0661 1.67372 2.84779 2.57202L1.10132 8.03667C0.737477 9.08469 1.3924 9.98299 2.48395 9.98299L5.39473 9.98299C5.83135 9.98299 6.19519 10.3573 6.12242 10.8813L5.75858 13.2767C5.61304 13.9505 6.04965 14.6991 6.70458 14.9236C7.28674 15.1482 8.01443 14.8488 8.30551 14.3996L11.2891 9.83327",
    stroke: "#333335",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.24574L15 10.5818C15 11.6299 14.5634 12.0042 13.5446 12.0042L12.8169 12.0042C11.7981 12.0042 11.3615 11.6299 11.3615 10.5818L11.3615 3.24574C11.3615 2.19772 11.7981 1.82343 12.8169 1.82343L13.5446 1.82343C14.5634 1.82343 15 2.19772 15 3.24574Z",
    stroke: "#333335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDislike, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dislike.04f396e8.svg";
export { ForwardRef as ReactComponent };